import { SegmentationIds } from 'constants/segmentation';

/**
 * Segmentation that should not redirected to CDP
 */
export const NO_REDIRECT_TO_CDP: Array<SegmentationIds> = [
  SegmentationIds.MixedLarge,
  SegmentationIds.MixedSmall,
];
